/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-17 14:40:00
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-09 14:46:34
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/RouterBlock/RouterBlock.tsx
 */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import Warning from '@/src/components/Antd/Modal/WarningModal';
import { getI18nFromGeneral } from '@/src/tools/tools';
const listener = (e) => {
  e.preventDefault();
  e.returnValue = '离开当前页后，所编辑的数据将不可恢复'; // 浏览器有可能不会提示这个信息，会按照固定信息提示
};

export default function UserConfirmationTwo(props) {
  const { active, onConfirm, okText, cancelText, onCancel: _onCancel } = props;

  const [isShowModal, setIsShowModal] = useState(false);
  const history = useHistory();
  const [nextLocation, setNextLocation] = useState(null);
  const [action, setAction] = useState<any>();
  const [unblock, setUnblock] = useState(null);

  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') {
      if (active) {
        window.addEventListener('beforeunload', listener);
      } else {
        window.removeEventListener('beforeunload', listener);
      }
    }
  }, [active]);

  useEffect(() => {
    if (!active && unblock) {
      unblock();
      setUnblock(null);
      return;
    }
    if (!active || unblock) {
      return;
    }
    // console.log('block');
    const cancelBlock = history.block((nextLocation, action): any => {
      //注册block

      const state: any = nextLocation.state;

      const { skipNotice } = state || { skipNotice: false };
      if (skipNotice) {
        return () => {
          return cancelBlock;
        };
      } else {
        if (active) {
          setIsShowModal(true);
        }
        setNextLocation(nextLocation);

        setAction(action);
        return false;
      }

      // history.push(nextLocation);
    });
    setUnblock(() => {
      return cancelBlock;
    });
  }, [active, unblock]);

  useEffect(() => {
    return () => {
      if (unblock) unblock();
      window.removeEventListener('beforeunload', listener);
    };
  }, []);
  const confrim = () => {
    if (action === 'PUSH') {
      history.push(nextLocation);
    } else if (action === 'POP') {
      history.goBack();
    } else if (action === 'REPLACE') {
      history.replace(nextLocation);
    }
    setIsShowModal(false);
  };
  function onOk() {
    if (unblock) unblock();
    if (onConfirm) onConfirm(confrim);
  }

  function onCancel() {
    setIsShowModal(false);
    if (_onCancel) _onCancel();
  }

  return (
    <>
      {/* <Prompt message='Are you sure you want to leave?' /> */}
      {isShowModal && (
        <Warning
          visible
          header={getI18nFromGeneral('general.commonHeader.discard_header')}
          onOk={onOk}
          okText={okText}
          cancelText={cancelText}
          onCancel={onCancel}>
          {getI18nFromGeneral('general.commonHeader.leave_content')}
        </Warning>
      )}
    </>
  );
}
///
